module.exports = __webpack_public_path__ + "static/media/logo72x72.f000af95.png";